import {
  BathroomsType,
  BedroomsType,
  RoomsType,
} from "@/types/SearchFilter.types";

export function summarizeFilters(
  items: Array<string | number | null | undefined>,
  separator: string = ", ",
): string {
  return items.filter((i) => i).join(separator);
}

export function summarizeCountFilters(
  items: RoomsType[] | BedroomsType[] | BathroomsType[],
  separator: string = ", ",
): string {
  const isHasFiveOrMore = items.some((i) => i >= 5);

  const data = [...items].sort((a, b) => a - b).filter((i) => i < 5);
  if (isHasFiveOrMore) {
    data.push("5+");
  }

  return data.join(separator);
}
